'use strict';

var index = require('../node_modules/@mui/utils/node_modules/react-is/index.cjs');

var reactIsExports = /*@__PURE__*/ index.__require();

exports.reactIsExports = reactIsExports;
//# sourceMappingURL=index8.cjs.map
